// https://github.com/DavidBruant/Map-Set.prototype.toJSON
require('./$.collection-to-json')('Map');


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-core/~/core-js/modules/es7.map.to-json.js
 ** module id = 160
 ** module chunks = 0
 **/